export interface Pagination {
	currentPage: number;
	pageSize: number;
	total: number;
}

export class PaginationDefaults {
	pageSize: number = 50;
	total: number = 0;
	currentPage: number = 0;
}
